import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { registerQueueHandler, enqueueOperation } from '@/sync/offlineSyncQueue.js';
import { log } from '@/utils/core/vueLogger.js';

async function sendDvpMailNow({ recipient, subject, body, filename, attachment }) {
	const formData = new FormData();
	formData.append('recipients', recipient);
	formData.append('subject', subject);
	formData.append('body', body);
	formData.append('filesToConvertToPDF', filename);
	formData.append('files', new File([attachment || body], filename, { type: 'text/html' }), filename);

	const response = await authenticatedFetch(getApiUrl('Communication/Mails/Send'), { method: 'POST', body: formData }, 'tokenSales');
	if (!response.ok) throw new Error(`Failed to send DVP mail: HTTP ${response.status}`);
}

registerQueueHandler('SEND_DVP_MAIL', sendDvpMailNow);

export function initDvpMailQueue() {
	window.addEventListener('message', (event) => {
		if (event.origin !== window.location.origin) return;
		if (event.data?.type !== 'QUEUE_DVP_MAIL_SEND') return;

		const { recipient, subject, body, filename, attachment } = event.data.payload;
		enqueueOperation('SEND_DVP_MAIL', { recipient, subject, body, filename, attachment }, `DVP mail: ${recipient}`);
		log('info', 'DvpMail', `📥 Queued offline DVP mail for ${recipient}`);
	});
}
